import { Grid, IconButton, Tooltip } from '@material-ui/core'
import Programa from '../../components/Programa/Programa'
import React, { useCallback, useEffect, useState } from 'react'
import { MdArrowBack, MdBlock } from 'react-icons/md'
import { Cadastro } from './Cadastro'
import { metodoPrograma } from '../../components/api'
import Table from '../../components/Table/Table'
import { FaCheckCircle } from 'react-icons/fa'
import { format } from 'date-fns';

const Denuncia = () => {
  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [objeto, setObjeto] = useState([])

  const getLista = useCallback(() => {
    metodoPrograma('listaDenuncia', {}).then((res) => {
      if (res.status) {
        if (res.lista) {
          setLista(res.lista)
        } else {
          setLista([])
        }
      }
    })
  }, [])

  const handleClick = (_, linha) => {
    setObjeto(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setTela('lista')
    setObjeto([])
    getLista()
  }

  useEffect(() => {
    getLista()
  }, [getLista])

  useEffect(() => {
    switch (tela) {
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlDenuncia" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              dados={lista}
              head={['Reporting user', 'Restrict user','Type', 'Report Date', 'Block user', 'Restrict user', 'Review date']}
              line={(l) => [l.userOrigem?.[1], l.userDestino?.[1], l.dsTipoDenuncia, format(l.dtDenuncia, 'MM/dd/yyyy - MM:SS'), l.snBloquear, l.snRestringir, l.dtRevisao]}
              onClick={handleClick}
              columnOptions={[
                {
                  alias: 4,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small">
                      {linhaOriginal.snBloquear ? <FaCheckCircle style={{color:'red'}} /> : <MdBlock style={{color:'green'}} /> }
                    </IconButton>
                  ),
                },
                {
                  alias: 5,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small">
                      {linhaOriginal.snRestringir ? <FaCheckCircle style={{color:'red'}} /> : <MdBlock style={{color:'green'}} /> }
                    </IconButton>
                  ),
                },
              ]}
            />
          </Grid>
        </Grid>
      ) : (
        <Cadastro {...{ objeto, voltar }} />
      )}
    </Programa>
  )
}

export default Denuncia
